import { FREQUENCY_TYPES } from "../../constants/Constants";
import ValidationMessage from "../../constants/ValidationMessage";
import * as yup from 'yup';


const AddExpensesValidation: any = yup.object().shape({
    hh_id: yup.string().required(ValidationMessage.SelectField("a household")),
    ec_id: yup.string().required(ValidationMessage.SelectField("an expense")),
    payer: yup.string().required(ValidationMessage.SelectField("a payer")),
    // desc: yup.string().required(ValidationMessage.Field("description")),
    desc: yup
        .string()
        .test(
            "no-more-than-6-consecutive-digits",
            "Please do not enter more than 6 consecutive numbers.",
            (value) => {
                if (!value) return true; // allow empty
                return !/\d{7,}/.test(value); // fail only if 7+ digits in a row
            }
        ),
    amount: yup
        .string()
        .required(ValidationMessage.Field("an amount"))
        .test(
            'amount-required',
            ValidationMessage.Field("amount more than 0"),
            function (value: any) {
                const { amount } = this.parent;
                if (Number(amount) === 0) return false;
                return true;
            }
        ),
    s_between: yup
        .array()
        .min(1, ValidationMessage.SelectField("at least 1 member"))
    ,
    f_value: yup
        .string()
        .nullable()
        .test(
            'frequency-required',
            ValidationMessage.SelectField("an interval."),
            function (value: any) {
                const { f_type } = this.parent;
                if (f_type != FREQUENCY_TYPES?.ONCE_ONLY) {
                    return !!value
                }
                return true;
            }
        ),
    e_date: yup
        .string()
        .test(
            'e_date-required',
            ValidationMessage.SelectField("an end date"),
            function (value: any) {
                const { f_type } = this.parent;
                if (f_type != FREQUENCY_TYPES?.ONCE_ONLY) {
                    return !!value
                }
                return true;
            }
        ),

    s_date: yup
        .string()
        .test(
            's_date-required',
            function (value: any) {
                const { f_type } = this.parent;
                let message;
                if (f_type == FREQUENCY_TYPES?.ONCE_ONLY) {
                    message = ValidationMessage.SelectField("a date");
                } else {
                    message = ValidationMessage.SelectField("a start date");
                }
                return !!value || this.createError({ message });
            }
        ),

    s_days_or_months: yup
        .array()
        .test(
            's_days_or_months-required',
            function (value: any) {
                const { f_type, s_days_or_months } = this.parent;
                let message;
                if (f_type == FREQUENCY_TYPES?.WEEKLY && (!s_days_or_months || s_days_or_months.length === 0)) {
                    message = ValidationMessage.SelectField("at least one day");
                } else if (f_type == FREQUENCY_TYPES?.MONTHLY && (!s_days_or_months || s_days_or_months.length === 0)) {
                    message = ValidationMessage.SelectField("at least one month");
                }
                if (message) { return this.createError({ message }); }
                return true;
            }
        ),

});

export default AddExpensesValidation